import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleApiError } from "../api/instanceApi";
import {
  getCourseCategories,
  getCourseContents,
  getCourseDetails,
  getEnrolledCourses,
  getModPageContent,
  enrollCourse,
  unenrollCourse,
  getTypeEnrol,
} from "../api/moodleCourseApi";

export const useHandleCourses = (id?: any) => {
  const queryClient = useQueryClient();


  const { data: enrolledCourses, isLoading: isEnrolledCoursesLoading } =
    useQuery({
      queryKey: ["enrolledCourses", id],
      queryFn: () => getEnrolledCourses(id),
      staleTime: 60000,
    });

  const enrolCourseMutation = useMutation({
    mutationFn: (courseId: any) => enrollCourse(courseId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["allCourses"],
      });
    },
    onError: handleApiError,
  });

  const unenrolCourseMutation = useMutation({
    mutationFn: (courseId: any) => unenrollCourse(courseId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["allCourses"],
      });
    },
  });

  const { data: typeEnrol, isLoading: isTypeEnrol } = useQuery({
    queryKey: ["type-enrolcourse"],
    queryFn: () => getTypeEnrol(),
    staleTime: 60000,
  });

  const { data: courseCategories, isLoading: isCourseCategoriesLoading } =
    useQuery({
      queryKey: ["course-categories"],
      queryFn: () => getCourseCategories(),
      staleTime: 60000,
    });

  const {
    data: courseDetails,
    isLoading: isCourseDetailsLoading,
    isError: isCourseDetailsError,
  } = useQuery({
    queryKey: ["course-details", id],
    queryFn: () => getCourseDetails(id),
    enabled: !!id,
    staleTime: 60000,
  });

  const {
    data: courseContents,
    isLoading: isCourseContentsLoading,
    isError: isCourseContentsError,
  } = useQuery({
    queryKey: ["course-contents", id],
    queryFn: () => getCourseContents(id),
    enabled: !!id,
    staleTime: 60000,
  });

  const {
    data: pageContent,
    isLoading: isPageContentLoading,
    isError: isPageContentError,
  } = useQuery({
    queryKey: ["mod-page-content", id],
    queryFn: () => getModPageContent(id),
    enabled: !!id,
    staleTime: 60000,
  });


  return {
    enrolledCourses,
    courseCategories,
    courseDetails,
    courseContents,
    pageContent,
    isCourseContentsLoading,
    isCourseDetailsLoading,
    isEnrolledCoursesLoading,
    isCourseCategoriesLoading,
    isPageContentLoading,
    selfEnroll: enrolCourseMutation.mutateAsync,
    unenrolCourseMutation,
    typeEnrol,
    isTypeEnrol,
  };
};
